import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import AnimatedSection from '../AnimatedSection';
import './Features.css';

const Features: React.FC = () => {
  const { t } = useTranslation();

  const features = [
    {
      key: 'offline',
      icon: '📴',
      image: '/images/feature-offline.png',
    },
    {
      key: 'curriculum',
      icon: '📚',
      image: '/images/feature-curriculum.png',
    },
    {
      key: 'organization',
      icon: '🏫',
      image: '/images/feature-organization.png',
    },
    {
      key: 'multiYear',
      icon: '📅',
      image: '/images/feature-multiyear.png',
    },
    {
      key: 'export',
      icon: '📤',
      image: '/images/feature-export.png',
    },
    {
      key: 'ai',
      icon: '🤖',
      image: '/images/feature-ai.png',
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <section className="features-section" id="features">
      <div className="features-container">
        <AnimatedSection className="features-header">
          <h2 className="section-title">{t('features.title')}</h2>
          <p className="section-subtitle">{t('features.subtitle')}</p>
        </AnimatedSection>
        
        <motion.div 
          className="features-grid"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-50px" }}
        >
          {features.map((feature) => (
            <motion.div key={feature.key} variants={item} className="feature-card">
              <div className="feature-card-content">
                <div className="feature-icon-wrapper">
                  <span className="feature-icon">{feature.icon}</span>
                </div>
                <h3 className="feature-title">
                  {t(`features.${feature.key}.title`)}
                </h3>
                <p className="feature-description">
                  {t(`features.${feature.key}.description`)}
                </p>
              </div>
              <div className="feature-card-image">
                 <img 
                    src={feature.image} 
                    alt={t(`features.${feature.key}.title`)}
                    loading="lazy" 
                 />
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
